import { ActionNames } from './index'

export default function(actionName: ActionNames) {
  return {
    input: `FETCH/${actionName}`,
    output: `FETCH/${actionName}/REVERSE`,
  }
}
